import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div style={{ 
      padding: '3rem 2rem', 
      maxWidth: '1000px', 
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif'
    }}>
      {/* Page Title */}
      <h1 style={{
        fontSize: '2.5rem',
        fontWeight: 'bold',
        color: '#2c5aa0',
        textAlign: 'center',
        marginBottom: '2rem'
      }}>
        Privacy Policy
      </h1>

      {/* Main Content */}
      <div style={{
        backgroundColor: '#ffffff',
        padding: '2.5rem',
        borderRadius: '16px',
        border: '1px solid #e9ecef',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
      }}>
        
        {/* Introduction */}
        <div style={{ marginBottom: '2.5rem' }}>
          <p style={{
            fontSize: '1.1rem',
            lineHeight: '1.7',
            color: '#333',
            margin: 0
          }}>
            At DataFre8, we are committed to respecting your privacy and protecting your personal data. We are based in Europe and operate in full alignment with the General Data Protection Regulation (GDPR) and other applicable European data protection laws.
          </p>
        </div>

        {/* Section 1: Who We Are */}
        <div style={{ marginBottom: '2.5rem' }}>
          <h2 style={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#2c5aa0',
            marginBottom: '1rem'
          }}>
            1. Who We Are
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0
          }}>
            DataFre8 is a European-based startup focused on building tools for 3D machine learning and computer vision. We take data privacy seriously and apply the principles of European data protection law in how we collect, process, and safeguard your information.
          </p>
        </div>

        {/* Section 2: What Personal Data We Collect */}
        <div style={{ marginBottom: '2.5rem' }}>
          <h2 style={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#2c5aa0',
            marginBottom: '1rem'
          }}>
            2. What Personal Data We Collect
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            marginBottom: '1rem'
          }}>
            We may collect the following types of personal data:
          </p>
          <ul style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: '0 0 1rem 0',
            paddingLeft: '1.5rem'
          }}>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Contact information:</strong> such as your name, email address, and company (if you contact us or sign up for updates).
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Usage data:</strong> including your IP address, browser type, pages visited, and time spent on our website.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Form submissions:</strong> any details you provide through our contact form or other forms.
            </li>
          </ul>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0
          }}>
            We do not knowingly collect sensitive personal data.
          </p>
        </div>

        {/* Section 3: How We Use Your Data */}
        <div style={{ marginBottom: '2.5rem' }}>
          <h2 style={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#2c5aa0',
            marginBottom: '1rem'
          }}>
            3. How We Use Your Data
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            marginBottom: '1rem'
          }}>
            We process your data for the following purposes:
          </p>
          <ul style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: '0 0 1rem 0',
            paddingLeft: '1.5rem'
          }}>
            <li style={{ marginBottom: '0.5rem' }}>To respond to your inquiries or support requests</li>
            <li style={{ marginBottom: '0.5rem' }}>To improve and maintain our website</li>
            <li style={{ marginBottom: '0.5rem' }}>To provide access to updates, documentation, or educational resources</li>
            <li style={{ marginBottom: '0.5rem' }}>To monitor and enhance platform performance and security</li>
          </ul>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0
          }}>
            We process your data lawfully, based on one or more of the following: your consent, our legitimate interests, or to fulfill a contract.
          </p>
        </div>

        {/* Section 4: Cookies and Analytics */}
        <div style={{ marginBottom: '2.5rem' }}>
          <h2 style={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#2c5aa0',
            marginBottom: '1rem'
          }}>
            4. Cookies and Analytics
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0
          }}>
            We use cookies for basic analytics and performance tracking (e.g., Google Analytics). These help us understand website usage and improve user experience. You can manage your cookie preferences via your browser settings.
          </p>
        </div>

        {/* Section 5: Sharing Your Data */}
        <div style={{ marginBottom: '2.5rem' }}>
          <h2 style={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#2c5aa0',
            marginBottom: '1rem'
          }}>
            5. Sharing Your Data
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0
          }}>
            We do not sell or share your personal data with third parties for marketing. We may share data with trusted service providers who help us operate our site (e.g., cloud hosting, analytics) — only as necessary and under strict confidentiality agreements.
          </p>
        </div>

        {/* Section 6: Your Rights (Under GDPR) */}
        <div style={{ marginBottom: '2.5rem' }}>
          <h2 style={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#2c5aa0',
            marginBottom: '1rem'
          }}>
            6. Your Rights (Under GDPR)
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            marginBottom: '1rem'
          }}>
            If you are located in the European Union (EU) or European Economic Area (EEA), you have specific rights under the General Data Protection Regulation (GDPR), including the right to:
          </p>
          <ul style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: '0 0 1rem 0',
            paddingLeft: '1.5rem'
          }}>
            <li style={{ marginBottom: '0.5rem' }}>Access your personal data</li>
            <li style={{ marginBottom: '0.5rem' }}>Correct or update inaccurate data</li>
            <li style={{ marginBottom: '0.5rem' }}>Request deletion of your data</li>
            <li style={{ marginBottom: '0.5rem' }}>Restrict or object to processing</li>
            <li style={{ marginBottom: '0.5rem' }}>Withdraw consent at any time</li>
            <li style={{ marginBottom: '0.5rem' }}>Lodge a complaint with a Data Protection Authority</li>
          </ul>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            marginBottom: '1rem'
          }}>
            We are committed to respecting privacy rights for all users, regardless of location. If you're outside the EU and have concerns or requests regarding your personal data, you are still welcome to contact us, and we will do our best to address them in line with our privacy values.
          </p>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0
          }}>
            To exercise your rights, contact us at{' '}
            <a 
              href="mailto:contact@datafre8.com"
              style={{
                color: '#2c5aa0',
                textDecoration: 'none',
                fontWeight: 'bold'
              }}
              onMouseEnter={(e) => {
                e.target.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.target.style.textDecoration = 'none';
              }}
            >
              contact@datafre8.com
            </a>.
          </p>
        </div>

        {/* Section 7: Data Retention */}
        <div style={{ marginBottom: '2.5rem' }}>
          <h2 style={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#2c5aa0',
            marginBottom: '1rem'
          }}>
            7. Data Retention
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0
          }}>
            We retain personal data only as long as necessary for the purposes described in this policy. We regularly review and delete data we no longer need.
          </p>
        </div>

        {/* Section 8: International Transfers */}
        <div style={{ marginBottom: '2.5rem' }}>
          <h2 style={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#2c5aa0',
            marginBottom: '1rem'
          }}>
            8. International Transfers
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0
          }}>
            Your data may be stored on servers located in the EU or securely processed outside the EU by trusted partners. When we transfer data outside the EU, we ensure it is protected under standard contractual clauses or equivalent safeguards.
          </p>
        </div>

        {/* Section 9: Updates to This Policy */}
        <div style={{ marginBottom: '2.5rem' }}>
          <h2 style={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#2c5aa0',
            marginBottom: '1rem'
          }}>
            9. Updates to This Policy
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0
          }}>
            We may update this Privacy Policy from time to time. Significant changes will be posted on this page with a revised "Effective Date."
          </p>
        </div>

        {/* Section 10: Contact Us */}
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '2rem',
          borderRadius: '12px',
          border: '1px solid #e9ecef'
        }}>
          <h2 style={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#2c5aa0',
            marginBottom: '1rem'
          }}>
            10. Contact Us
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.6',
            color: '#333',
            marginBottom: '1rem'
          }}>
            If you have questions about this Privacy Policy or how we handle your data, you can reach us at:
          </p>
          <p style={{
            fontSize: '1.1rem',
            lineHeight: '1.6',
            color: '#333',
            margin: 0,
            fontWeight: 'bold'
          }}>
            📧{' '}
            <a 
              href="mailto:privacy@datafre8.com"
              style={{
                color: '#2c5aa0',
                textDecoration: 'none'
              }}
              onMouseEnter={(e) => {
                e.target.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.target.style.textDecoration = 'none';
              }}
            >
              privacy@datafre8.com
            </a>
          </p>
        </div>

      </div>
    </div>
  );
};

export default Privacy; 